import view from './view'
export {view}


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/bulk_Import/index.js